import React, { useState, useContext } from 'react';

import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@material-ui/core/FormGroup';
import LinearProgress from '@material-ui/core/LinearProgress';

import clsx from 'clsx';

import useInterval from 'hooks/useInterval/useInterval';
import { invalidNPIForCreateProvider } from 'hooks/useMainDataManager/useMainDataManager';

import { AppContext } from '../../containers/Main';
import Footer from '../Footer/Footer';
import { useStyles } from './styles';

const ProviderConfirm = ({ provider, setFormStep }: any) => {
  const classes = useStyles();
  const { submitForm, email, password, confirmedProvider, loading }: any = useContext(AppContext);

  const [barValue, setBarValue] = useState(0);
  const [checkOne, setCheckOne] = useState(false);
  const [checkTwo, setCheckTwo] = useState(false);

  useInterval(
    () => {
      // Your custom logic here
      setBarValue(barValue + (barValue === 66 ? 34 : 33));
    },
    // Delay in milliseconds or null to stop it
    barValue < 100 ? 1000 : null,
  );

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.target.name === 'checkOne' ? setCheckOne(event.target.checked) : setCheckTwo(event.target.checked);
  };

  const handleSubmitForm = () => {
    const data = {
      acceptBaa: checkTwo,
      acceptTerms: checkOne,
      email: email,
      partner_site_id: '',
      password: password,
    };
    if (confirmedProvider.provider_id !== invalidNPIForCreateProvider) {
      // @ts-ignore
      data.provider_id = confirmedProvider.provider_id;
    }
    submitForm(data);
  };

  return (
    <>
      <p className={classes.italicBig}>Creating your account...</p>
      <LinearProgress
        classes={{
          root: classes.linearRoot,
          colorPrimary: classes.linearColorPrimary,
          bar: clsx({ [classes.linearBar]: barValue !== 100, [classes.linearBarComplete]: barValue === 100 }),
        }}
        variant="determinate"
        value={barValue}
      />
      <p className={classes.italicMedium}>Before you continue, we need you to confirm these:</p>
      <div className={classes.checkContainer}>
        <FormGroup row>
          <FormControlLabel
            control={<Checkbox classes={{root: classes.checkRoot}} checked={checkOne} onChange={handleChange} name="checkOne" color="primary" />}
            label={
              <div className={classes.checkText}>
                Checking this box indicates your acceptance of the{' '}
                <a href="https://www.doctor.com/terms-of-service" target="_blank">Terms of Service</a> and will act as your electronic
                signature on the <a href="https://www.doctor.com/baa" target="_blank">Business Associate Agreement</a>
              </div>
            }
          />
        </FormGroup>
      </div>
      <div className={classes.checkContainer}>
        <FormGroup row>
          <FormControlLabel
            control={<Checkbox classes={{root: classes.checkRoot}} checked={checkTwo} onChange={handleChange} name="checkTwo" color="primary" />}
            label={
              <div className={classes.checkText}>
                Checking this box confirms that you are a healthcare professional authorized to make changes to public
                data on a provider’s behalf
              </div>
            }
          />
        </FormGroup>
      </div>
      <Footer
        buttonLabel={loading ? 'Please wait...' : 'Go to my account'}
        buttonCallback={handleSubmitForm}
        buttonDisabled={!checkOne || !checkTwo || loading}
      />
    </>
  );
};
export default ProviderConfirm;
